const templates = [
    {
        'id': 0,
        'template': 'When {{subspace}}, the {{agg}} {{measure}} is {{parameter}}.',
    },
    {
        'id': 1,
        'template': 'When {{subspace}}, the value of the {{agg}} {{measure}} is {{parameter}}.',
    },
    {
        'id': 2,
        'template': 'When {{subspace}}, the {{agg}} value of {{measure}} is {{parameter}}.',
    },
]

export default templates;